import API from './api';
import { getToken} from '../util/sessionUtil';

export const userService = {
    //login,
    logout,
    getInvoice,
    downloadFile
};

function getInvoice(reqBody) {

    const configHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + getToken()
        }
    }

    const data = JSON.stringify(reqBody);

    return API.post("/shipment/api/invoices", data, configHeader)
        .then(response => {
            if (response.status !== 200) {
                return Promise.reject(response.statusText);
            }
            return response.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

function downloadFile(reqBody, token) {
	console.log("Calling File download REST API.");
	
	const configHeader = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': 'true',
            'responseType': 'arraybuffer',
            'x-nmsc-code': reqBody.nmsccode,
            'Authorization': 'Bearer ' + getToken()
        }
    }
	const data = JSON.stringify( {'file': reqBody.invoiceDate + '-' + reqBody.filename} );
	
    return API.post(`/shipment/invoice/${reqBody.invoiceNumber}`, data, configHeader);
}

function logout() {
    // remove user from local storage to log user out
	sessionStorage.removeItem('user');
}
